import { fetchWrapper } from '@/_helpers';

export const chatroomsApi = {
    findRoomByTeamAndTitle: (teamId, title) => {
        const query = new URLSearchParams({ teamId, title, limit: '1', page: '1' }).toString();
        return fetchWrapper.get(`chatrooms?${query}`);
    },
    createRoom: ({ team, title, subTitle, type = 'private', operationType = 'normal', addresses = [] }) => {
        return fetchWrapper.post('chatrooms', { team, title, subTitle, type, operationType, addresses });
    },
};
